import heroImg from '@/assets/carvoeiro-hero.jpg';
import logoMark from '@/assets/rocha-brava-mark.svg';

export function HeroBanner() {
  return (
    <div
      className="hero-banner"
      role="img"
      aria-label="Carvoeiro Nav — Rocha Brava Village Resort, Carvoeiro cliffs at golden hour"
    >
      <img className="hero-banner__img" src={heroImg} alt="" loading="eager" />
      <div className="hero-banner__scrim" aria-hidden />
      <div className="hero-banner__servicemark" aria-label="Carvoeiro Nav">
        <img className="hero-banner__logomark" src={logoMark} alt="" aria-hidden width={64} height={52} />
        <span className="hero-banner__wordmark-wrap">
          <span className="hero-banner__wordmark">Carvoeiro Nav</span>
        </span>
        <span className="hero-banner__submark">Rocha Brava · Carvoeiro</span>
      </div>
    </div>
  );
}
